"use client";
import * as React from "react";
const SvgCalculateSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.88 0 9.3 5.52l1.12 1.1L16 1.12zM2.38 4.1v2.34h1.57V4.09h2.37V2.53H3.95V.2H2.37v2.34H0V4.1zm6.91 10.8 1.12 1.1 2.24-2.21L14.88 16 16 14.9l-2.24-2.21L16 10.48l-1.12-1.1-2.23 2.2-2.24-2.2-1.12 1.1 2.24 2.2zM0 10.34h6.32v1.57H0zm6.32 3.13H0v1.56h6.32zM11.07.97a.8.8 0 0 1-.8.78.8.8 0 0 1-.78-.78c0-.43.35-.78.78-.78s.8.35.8.78m3.95 5.47c.43 0 .79-.35.79-.78a.8.8 0 0 0-.8-.78.8.8 0 0 0-.78.78c0 .43.35.78.79.78", clipRule: "evenodd" }));
export {
  SvgCalculateSharp as default
};
